import { render, staticRenderFns } from "./TakeIndex.vue?vue&type=template&id=2503f4ae&scoped=true&"
import script from "./TakeIndex.vue?vue&type=script&lang=js&"
export * from "./TakeIndex.vue?vue&type=script&lang=js&"
import style0 from "./TakeIndex.vue?vue&type=style&index=0&id=2503f4ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2503f4ae",
  null
  
)

export default component.exports